import script from "./message-abstract-text.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-abstract-text.vue?vue&type=script&setup=true&lang=ts"

import "./message-abstract-text.vue?vue&type=style&index=0&id=6e21a172&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e21a172"]])

export default __exports__